import React from "react";
import { map, pluck, zipObj } from "ramda";
import { connect } from "react-redux";
import Autocomplete from "components/Autocomplete";
import { setFacetDialogSelectedTerms } from "browse-media/redux/browseMediaActions";

const getAutocompleteValue = map(t => t.code);
const getAutocompleteSource = availableTerms =>
  zipObj(
    pluck("code", availableTerms),
    map(t => `${t.label} (${t.count.toLocaleString()})`, availableTerms),
  );

const BrowseMediaFacetAutocomplete = ({
  availableTerms,
  displayName,
  onChange,
  selectedTerms,
}) => (
  <Autocomplete
    direction="down"
    onChange={termCodes =>
      onChange(availableTerms.filter(t => termCodes.includes(t.code)))
    }
    label={`Choose ${displayName}`}
    source={getAutocompleteSource(availableTerms)}
    value={getAutocompleteValue(selectedTerms)}
  />
);

const mapStateToProps = state => state.browseMedia.facetDialog;

const mapDispatchToProps = dispatch => ({
  onChange: selectedTerms =>
    dispatch(setFacetDialogSelectedTerms(selectedTerms)),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  BrowseMediaFacetAutocomplete,
);
